'use strict';

angular
    .module('app.influencerGroup')
    .factory('influencerGroupService', ['$q', '$http', '$rootScope',
        function ($q, $http, $rootScope) {
            var service = {};

            function checkResponse(data) {
              return data;
            }

            function getMessage(data) {
              if (data) {
                return data.message;
              }
              return false;
            }

            function handleRequest(url, method, params, loader) {
                var deferred = $q.defer();

                var req = {
                    url: url,
                    method: method,
                    data: JSON.stringify(params),
                    loader: loader
                } 

                $http(req)
                    .success(function (data) {
                    var dataRes = angular.fromJson(data);

                    if (checkResponse(dataRes)) {
                        deferred.resolve(dataRes);
                    } else {
                        deferred.reject(getMessage(dataRes));
                    }
                })
                    .error(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            }

            function getInfluencerGroupList(selected_company_id, loader) {
                var url_getInfluencerGroupList = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupList?selected_company_id=' + selected_company_id;
                return handleRequest(url_getInfluencerGroupList, 'GET', null, loader);
            }

            function deleteInfluencerGroup(params, loader) {
                var url_deleteInfluencerGroup = $rootScope.apiUrl + 'influencerGroup/deleteInfluencerGroup';
                return handleRequest(url_deleteInfluencerGroup, 'POST', params, loader);
            }

            service.getInfluencerGroupList = getInfluencerGroupList;
            service.deleteInfluencerGroup = deleteInfluencerGroup;

            return service;
        }
    ])

    
